<form
  [formGroup]="deauthForm"
  [bitSubmit]="submit"
  bit-dialog
  dialogSize="default"
  class="bv-account-dialog"
  [title]="'deauthorizeSessions' | i18n"
>
  <ng-container bitDialogContent>
    <p class="bv-account-dialog__body-text">{{ "deauthorizeSessionsDesc" | i18n }}</p>
    <bit-callout type="warning" icon="bwi-info-circle">{{
      "deauthorizeSessionsWarning" | i18n
    }}</bit-callout>
    <app-user-verification-form-input
      formControlName="verification"
      name="verification"
      [(invalidSecret)]="invalidSecret"
    ></app-user-verification-form-input>
  </ng-container>
  <ng-container bitDialogFooter>
    <div class="bv-account-dialog__footer-end">
      <button
        bitButton
        bitFormButton
        type="button"
        buttonType="secondary"
        class="bv-account-dialog__cancel-btn"
        bitDialogClose
      >
        {{ "cancel" | i18n }}
      </button>
      <button
        bitButton
        bitFormButton
        type="submit"
        buttonType="danger"
        class="bv-account-dialog__danger-fill-btn"
      >
        {{ "deauthorizeSessions" | i18n }}
      </button>
    </div>
  </ng-container>
</form>
